import React from 'react'
import { useStore } from '../../../../../lib/context'
import { observer } from 'mobx-react-lite'
import {motion} from 'framer-motion'

const NavModuleCommunitySection = () => {

    return (
        <motion.div
            className='flex nav--community'
            initial={{ opacity: 0, y: 3}}
            animate={{ opacity: 1, y: 0}}
            exit={{ opacity: 0, y: -1}}
            transition={{delay: .25}}
        >

            <CommunityLink label="Business" pluralLabel="Businesses" color="#956cf1">
                Businesses
            </CommunityLink>

            <CommunityLink label="Contributor" pluralLabel="Community" color="rgb(245, 143, 245)">
                Contributors
            </CommunityLink>

            <CommunityLink  label="Collaborator" pluralLabel="Community" color="rgb(145, 215, 214)">
                Collaborators
            </CommunityLink>

            <CommunityLink label="Resources" pluralLabel="Community" color="#ffda3b">
                Resources
            </CommunityLink>
        </motion.div>
    )
}


const CommunityLink = observer(({children, label, color, pluralLabel}) => {
    const {uiStore: {updateCommunityActiveTab, community__activeTab}} = useStore();
    const tab = {label, color, pluralLabel};

	const handleClick = () => {
		// updateCommunityMobileMenuOpen(true)
		if (false) {
			updateCommunityActiveTab(null)
			window.history.pushState('Community', 'Community', '/bloomseason/community')
		} else {
			updateCommunityActiveTab(tab)
			window.history.pushState(
				tab.label,
				tab.label,
				`/bloomseason/community/${tab.label.toLowerCase()}`
			)
		}
	}

    const isActive = community__activeTab && community__activeTab.label === label;


    return (
        <div 
            className={isActive ? "community-link active" : "community-link"}
            onClick={handleClick}
        >
            {children}


        </div>
    )
})

export default NavModuleCommunitySection